import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Network$dJsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic$dPromotions$dRPC$dSites$dTypes from "../Restaumatic.Promotions.RPC.Sites.Types/index.js";
import * as Restaumatic$dSite$dRPC from "../Restaumatic.Site.RPC/index.js";
const member = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = false;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer.compare(k)(v._3);
        if (v1.tag === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1.tag === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1.tag === "EQ") {
          go$c = false;
          go$r = true;
          continue;
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const sitesRPC = /* #__PURE__ */ Restaumatic$dSite$dRPC.sitesRPC(/* #__PURE__ */ Network$dJsonRPC.encodeRequest(Restaumatic$dPromotions$dRPC$dSites$dTypes.encodeGetActivePromotionsRequest)({
  encodeWithOptions: v => Restaumatic$dPromotions$dRPC$dSites$dTypes.encodeGetActivePromotionsRequest.encode
}))(/* #__PURE__ */ Network$dJsonRPC.decodeResponse(Restaumatic$dPromotions$dRPC$dSites$dTypes.decodeGetActivePromotionsResponse))(Restaumatic$dPromotions$dRPC$dSites$dTypes.rPCMethodNameGetActivePro);
const filterPromotions = v => v1 => {
  if (v1.tag === "Right") {
    return Data$dEither.$Either(
      "Right",
      {
        promotions: Data$dArray.filterImpl(p => member(v)(Data$dRecord.unsafeGet("enabledMenuConsumers")(p)), Data$dRecord.unsafeGet("promotions")(v1._1)),
        coupons: Data$dRecord.unsafeGet("coupons")(v1._1)
      }
    );
  }
  return v1;
};
const getActivePromotions = menuConsumer => {
  const $0 = Effect$dAff._map(Data$dEither.functorEither.map(filterPromotions(menuConsumer)));
  return x => $0(sitesRPC(x));
};
const promotionsBackend = {getActivePromotions};
export {filterPromotions, getActivePromotions, member, promotionsBackend, sitesRPC};
